import { create } from "zustand";
import type { FilterStand, Sortering } from "@xxtract/tabelfilters";
import { useAuthStore } from "./authStore";
import { useSimulationStore } from "./simulationStore";

export type Weergave = "raster" | "lijst" | "producten";

/** Stand van één lijst (spec-tabelfilters §7). */
export interface LijstStand {
  filters: FilterStand;
  sortering: Sortering;
  pagina: number;
  paginagrootte?: number;
  weergave?: Weergave;
  /** Paginafilter waarvan een wijziging deze lijst op pagina 1 zet. */
  afhankelijkVan?: string;
}

interface LijstStandState {
  standen: Record<string, LijstStand>;
  zet: (sleutel: string, deel: Partial<LijstStand>) => void;
  zetPaginafilter: (sleutel: string, filters: FilterStand) => void;
  wisAlles: () => void;
}

const LEEG: LijstStand = { filters: {}, sortering: [], pagina: 1 };

/**
 * Alleen in het werkgeheugen, bewust zonder `persist`: verversen, een nieuw tabblad, uitloggen en
 * wisselen van "Bekijk als klant" beginnen bij de standaard (CAP-14).
 */
export const useLijstStandStore = create<LijstStandState>((set) => ({
  standen: {},
  zet: (sleutel, deel) =>
    set((s) => ({
      standen: {
        ...s.standen,
        [sleutel]: { ...LEEG, ...s.standen[sleutel], ...deel },
      },
    })),
  zetPaginafilter: (sleutel, filters) =>
    set((s) => {
      const standen: Record<string, LijstStand> = {};
      for (const [k, stand] of Object.entries(s.standen))
        standen[k] =
          stand.afhankelijkVan === sleutel ? { ...stand, pagina: 1 } : stand;
      standen[sleutel] = { ...LEEG, ...s.standen[sleutel], filters };
      return { standen };
    }),
  wisAlles: () => set({ standen: {} }),
}));

// Eén plek die wist: ook sessieverloop (de 401-afhandeling roept `logout` zonder `useAuth`).
useAuthStore.subscribe((nu, vorig) => {
  if (vorig.isAuthenticated && !nu.isAuthenticated)
    useLijstStandStore.getState().wisAlles();
});
useSimulationStore.subscribe((nu, vorig) => {
  if (
    nu.isSimulating !== vorig.isSimulating ||
    nu.simulatedGln !== vorig.simulatedGln
  )
    useLijstStandStore.getState().wisAlles();
});
